"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericUSDManager = void 0;
//TODO temporal. Debería de decidirse desde fuera cual de los dos UsdManager cargar
class GenericUSDManager {
    constructor(mockUsdManager, usdManager) {
        this.getInformation = () => {
            try {
                return this.usdManager.getInformation();
            }
            catch (e) {
                return this.mockUsdManager.getInformation();
            }
        };
        this.getMethods = () => {
            try {
                return this.usdManager.getMethods();
            }
            catch (e) {
                return this.mockUsdManager.getMethods();
            }
        };
        this.initMethods = () => {
            throw new Error('initMethods not implemented');
        };
        this.parseInformation = (_data) => {
            throw new Error('parseInformation not implemented');
        };
        this.parseMethods = (_data) => {
            throw new Error('parseMethods not implemented');
        };
        this.mockUsdManager = mockUsdManager;
        this.usdManager = usdManager;
    }
}
exports.GenericUSDManager = GenericUSDManager;
//# sourceMappingURL=genericUsdManager.js.map